export class BarChartData {
    public labels: Array<string>;
    public datasets: Array<BarChartDataSet>;

    constructor() {
        this.labels = [];
        this.datasets = [];
    }
}

class BarChartDataSet {
    public label: string;
    public data: Array<number>;
    public backgroundColor!: string;
    public borderColor!: string;

    constructor() {
        this.label = "";
        this.data = [];
    }
}

export class TimeChartData {
    public datasets: Array<TimeChartDataSet>;

    constructor() {
        this.datasets = [];
    }
}

export class TimeChartDataSet {
    public label: string;
    public data: Array<TimeData>;
    public backgroundColor!: string;
    public borderColor!: string;
    public yAxisID?: string;

    constructor() {
        this.label = "";
        this.data = [];
    }
}

class TimeData {
    public x: any;
    public y!: number;
}